import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    font-size: 100%;
    
    @media (max-width: 768px) {
      font-size: 93.75%; /* 15px */
    }
    
    @media (max-width: 480px) {
      font-size: 87.5%; /* 14px */
    }
  }

  body {
    font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
    background-color: #121212;
    color: #ffffff;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    width: 100%;
  }

  button, input, select, textarea {
    font-family: inherit;
    font-size: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    font-weight: 600;
    line-height: 1.2;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  img, svg {
    max-width: 100%;
    display: block;
  }

  ul, ol {
    list-style: none;
  }

  #root {
    min-height: 100vh;
    width: 100%;
  }
`;

export default GlobalStyles; 